import { enumChartElement, enumFillMode, kDefaultFontSize } from "../constants";
import { QFieldDraggerPanel } from "./QFieldDraggerPanel";

export class QLayoutDragPanel extends QFieldDraggerPanel {
  constructor() {
    super();
  }

  PrepInteractWithElement(controlElement, x, y) {
    var hitTest = this.fDestPanel.HitTest(x, y, null);
    this.fDestPanel.ClearSelection();
    if (hitTest.fPanelHit != null) {
      var theElement = hitTest.fElementHit;
      var elementType;
      if (theElement != null) {
        elementType = theElement.GetElementType();
        if (elementType == enumChartElement.boxCell)
          this.fDestPanel.DoSelectElement(theElement, true);
      }
    }
  }

  DragComplete() {
    var sourceElement = this.GetSourceElement();
    var theElement = this.fDestPanel.GetFirstSelectedElement(enumChartElement.boxCell);

    if (sourceElement == theElement) return;

    var srcDesc = sourceElement.GetCellDesc();
    if (theElement != null) {
      var dstDesc = theElement.GetCellDesc();
      dstDesc.ReplaceFormat(srcDesc, true);
      if (sourceElement.IsMergedCell()) {
        theElement.ReplaceMerge(sourceElement);
      }
    }
    if (sourceElement != null) {
      sourceElement.SetField(null);
      srcDesc.SetCellFillMode(enumFillMode.noFill);
      srcDesc.SetFontSize(kDefaultFontSize); // Fixme
    }

    this.fDestPanel.RebuildLayout();
  }
}
